// List of all V5 icons that are supported by `Icon`. These map directly
// to the names of `.svg` files. To add an `Icon`, add the `.svg`
// file to the appropriate location and then add the icon to this object.
// This map is for Storybook (Icon Docs page).

/** @deprecated */
export const iconNames = {
  actionAIFix: true,
  actionAIText: true,
  actionAttachment: true,
  actionAutoRenew: true,
  actionBookmark: true,
  actionBookmarkFill: true,
  actionBug: true,
  actionBugFill: true,
  actionBuild: true,
  actionCalendar: true,
  actionCalendarFill: true,
  actionCamera: true,
  actionCameraFill: true,
  actionCheckConnection: true,
  actionCheckConnectionFill: true,
  actionCompare: true,
  actionCopy: true,
  actionCopyFill: true,
  actionDownload: true,
  actionDrag: true,
  actionEdit: true,
  actionEditAi: true,
  actionEditAiFill: true,
  actionEditCircle: true,
  actionEditCircleFill: true,
  actionEditFill: true,
  actionEmail: true,
  actionEmailFill: true,
  actionExplore: true,
  actionExploreFill: true,
  actionFallback: true,
  actionFilter: true,
  actionFlag: true,
  actionFlagFill: true,
  actionFormula: true,
  actionInput: true,
  actionInsert: true,
  actionOutput: true,
  actionLink: true,
  actionLock: true,
  actionLockFill: true,
  actionMoveToFolder: true,
  actionMoveToFolderFill: true,
  actionPhoto: true,
  actionPhotoFill: true,
  actionPin: true,
  actionPinFill: true,
  actionPlay: true,
  actionPlayFill: true,
  actionRename: true,
  actionReadAloud: true,
  actionReadAloudFill: true,
  actionRenameFill: true,
  actionResend: true,
  actionResendFill: true,
  actionSend: true,
  actionSendFill: true,
  actionShare: true,
  actionShareFill: true,
  actionSwitchAccount: true,
  actionSwitchAccountFill: true,
  actionTest: true,
  actionTrash: true,
  actionTrashFill: true,
  actionUpload: true,
  actionZapDetails: true,
  actionZapDetailsFill: true,
  alertCircle: true,
  alertCircleFill: true,
  alertCircleColor: true,
  alertInfo: true,
  alertInfoFill: true,
  alertTriangle: true,
  alertTriangleFill: true,
  arrowBigDown: true,
  arrowBigLeft: true,
  arrowBigRight: true,
  arrowBigUp: true,
  arrowBranch: true,
  arrowCode: true,
  arrowCodeDots: true,
  arrowConnect: true,
  arrowContract: true,
  arrowDropdown: true,
  arrowDropdownCircle: true,
  arrowExit: true,
  arrowExpand: true,
  arrowLineLeft: true,
  arrowLineRight: true,
  arrowOffsite: true,
  arrowRedo: true,
  arrowRefresh: true,
  arrowResizeDiagonalLeft: true,
  arrowResizeDiagonalRight: true,
  arrowResizeHorizontal: true,
  arrowSelect: true,
  arrowSmallDown: true,
  arrowSmallLeft: true,
  arrowSmallRight: true,
  arrowSmallUp: true,
  arrowUndo: true,
  arrowZoom: true,
  arrowZoomReverse: true,
  commentAdd: true,
  commentAddFill: true,
  commentBlank: true,
  commentBlankFill: true,
  commentConvo: true,
  commentConvoFill: true,
  commentFilled: true,
  commentFilledFill: true,
  commentWaiting: true,
  commentWaitingFill: true,
  fileAdd: true,
  fileAddFill: true,
  fileFile: true,
  fileFileFill: true,
  fileFilled: true,
  fileFilledFill: true,
  fileGuide: true,
  fileGuideFill: true,
  fileSecurity: true,
  fileRemove: true,
  fileRemoveFill: true,
  formAdd: true,
  formAddCircle: true,
  formAddCircleOutlined: true,
  formAddSquare: true,
  formAddSquareOutlined: true,
  formBlank: true,
  formCheck: true,
  formCheckCircle: true,
  formCheckCircleOutlined: true,
  formCheckPlus: true,
  formCheckSquare: true,
  formCheckSquareOutlined: true,
  formDash: true,
  formDashCircle: true,
  formDashCircleOutlined: true,
  formDashSquare: true,
  formDashSquareOutlined: true,
  formRadioCheck: true,
  formRadioDot: true,
  formRadioUnchecked: true,
  formText: true,
  formTextLong: true,
  formTextAlignCenter: true,
  formTextAlignLeft: true,
  formTextAlignRight: true,
  formToggle: true,
  formX: true,
  formXCircle: true,
  formXCircleOutlined: true,
  miscAI: true,
  miscAIFill: true,
  miscAt: true,
  miscBolt: true,
  miscBoltAlt: true,
  miscBoltAltFill: true,
  miscBoltFill: true,
  miscBoltOutlined: true,
  miscBundle: true,
  miscDomain: true,
  miscCheckpoint: true,
  miscClock: true,
  miscClockFill: true,
  miscClockPlay: true,
  miscCloud: true,
  miscCloudCheck: true,
  miscCloudCheckFill: true,
  miscCloudFill: true,
  miscColor: true,
  miscColorFill: true,
  miscCookie: true,
  miscCookieFill: true,
  miscCopilot: true,
  miscCreditCard: true,
  miscCreditCardFill: true,
  miscDollar: true,
  miscErrorHandler: true,
  miscEvergreenAI: true,
  miscEye: true,
  miscEyeClosed: true,
  miscEyeFill: true,
  miscFingerprint: true,
  miscFire: true,
  miscFireFill: true,
  miscGraph: true,
  miscGraphBox: true,
  miscGraphBoxFill: true,
  miscHand: true,
  miscHandFill: true,
  miscHeadset: true,
  miscHeadsetFill: true,
  miscIdea: true,
  miscLearn: true,
  miscLearnFill: true,
  miscList: true,
  miscMCP: true,
  miscMic: true,
  miscMicFill: true,
  miscPackage: true,
  miscPie: true,
  miscPieFill: true,
  miscPin: true,
  miscPinFill: true,
  miscSecurity: true,
  miscSecurityFill: true,
  miscSteps: true,
  miscSteps1: true,
  miscSteps2: true,
  miscSteps3: true,
  miscStepsAlt: true,
  miscStepsFill: true,
  miscTimelapse: true,
  miscTrigger: true,
  miscUptime: true,
  miscUptimeFill: true,
  miscWallet: true,
  miscWalletFill: true,
  miscWorld: true,
  miscWorldFill: true,
  navAIChatbot: true,
  navAgents: true,
  navApps: true,
  navAppsEdit: true,
  navAppsFill: true,
  navAssets: true,
  navAssetsFill: true,
  navBell: true,
  navBellFill: true,
  navBlog: true,
  navBlogFill: true,
  navBriefcase: true,
  navBriefcaseFill: true,
  navCanvas: true,
  navCog: true,
  navCogFill: true,
  navConnectedAssets: true,
  navConnectedAssetsFill: true,
  navCustomAction: true,
  navDashboard: true,
  navDashboardFill: true,
  navExplore: true,
  navExploreFill: true,
  navFolder: true,
  navFolderFill: true,
  navFunctions: true,
  navGridView: true,
  navHelp: true,
  navHelpFill: true,
  navHome: true,
  navHomeFill: true,
  navIntegrations: true,
  navIntegrationsFill: true,
  navInterfaces: true,
  navLeadRouter: true,
  navMCP: true,
  navMenu: true,
  navMenuAlt: true,
  navMoreHoriz: true,
  navMoreVert: true,
  navProductHub: true,
  navProjects: true,
  navProjectsFill: true,
  navSearch: true,
  navSearchFill: true,
  navTable: true,
  navTables: true,
  navTableFill: true,
  navTemplate: true,
  navTemplateFill: true,
  navVersions: true,
  navVersionsFill: true,
  partnerDashboard: true,
  partnerEmbed: true,
  personAdd: true,
  personAddFill: true,
  personCircle: true,
  personCircleFill: true,
  personGroup: true,
  personGroupAdd: true,
  personGroupFill: true,
  personKey: true,
  personOne: true,
  personOneFill: true,
  personSecurity: true,
  personSettings: true,
  ratingCool: true,
  ratingHappy: true,
  ratingHappyAlt: true,
  ratingHeart: true,
  ratingHeartFill: true,
  ratingNeutral: true,
  ratingNeutralAlt: true,
  ratingSad: true,
  ratingSadAlt: true,
  ratingStar: true,
  ratingStarFill: true,
  ratingThumbsBoth: true,
  ratingThumbsBothFill: true,
  ratingThumbsDown: true,
  ratingThumbsDownFill: true,
  ratingThumbsUp: true,
  ratingThumbsUpFill: true,
  ratingVeryHappy: true,
  ratingVeryHappyAlt: true,
  ratingVerySad: true,
  ratingVerySadAlt: true,
  ratingWink: true,
  ratingWinkAlt: true,
  socialFacebook: true,
  socialGoogle: true,
  socialInstagram: true,
  socialLinkedIn: true,
  socialX: true,
  socialYouTube: true,
  statusAppApproval: true,
  statusAppApprovalFill: true,
  statusFilter: true,
  statusFilterFill: true,
  statusPaused: true,
  statusPlaying: true,
  statusPlayingFill: true,
  statusStatus: true,
  statusStatusFill: true,
  statusStop: true,
  statusStopFill: true,
  team: true,
  teamFill: true,
  zapierLogo: true,
} as const;

/** @deprecated */
export type IconName = keyof typeof iconNames;
